
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;

  --sic-accordion-block--default--layout-gap:var(--grid-gap);

  --sic-accordion-block--default--border-radius:var(
  --border-radius-rounded-default
);

  --sic-accordion-block--default--outer-spacing:clamp(
  var(--spacing-08),
  calc(0.5rem + 3.75vw),
  var(--spacing-20)
);

  --sic-accordion-block--default--content-padding:clamp(
  var(--spacing-05),
  calc(-3.333rem + 11.458vw),
  var(--spacing-16)
);

  --sic-accordion-block--default--content-spacing:var(--spacing-04);

  --sic-accordion-block--default--accordion-spacing-above:var(--spacing-08);

  --sic-accordion-block--default--content-font-size:var(--body-03-font-size);

  --sic-accordion-block--default--content-line-height:var(--body-03-line-height);

  --layout-gap:var(
    --sic-accordion-block--layout-gap,
    var(--sic-accordion-block--default--layout-gap)
  );
  --sic-body-text--font-size:var(
    --sic-accordion-block--default--content-font-size
  );
  --sic-body-text--line-height:var(
    --sic-accordion-block--default--content-line-height
  );
}

.sic-accordion-block--inner{
  border-radius:var(--sic-accordion-block--default--border-radius);
  border-radius:var(
    --sic-accordion-block--border-radius,
    var(--sic-accordion-block--default--border-radius)
  );
  overflow:hidden;
}

.layout-container{
  padding:var(--sic-accordion-block--default--content-padding);
  padding:var(
    --sic-accordion-block--content-padding,
    var(--sic-accordion-block--default--content-padding)
  );
}

.layout-container.layout-stacked{
    display:flex;
    flex-direction:column;
    row-gap:var(--spacing-3);
  }

@media (min-width: 1024px){

.layout-container{
    display:grid;
    grid-template-columns:calc(1 / 3 * calc(100% - var(--layout-gap))) calc(
        2 / 3 * calc(100% - var(--layout-gap))
      );
    grid-template-rows:1fr;
    grid-column-gap:var(--layout-gap);
    grid-row-gap:0px
}
  }

.layout-stacked .accordion-wrapper{
    padding-block-start:var(--sic-accordion-block--default--accordion-spacing-above);
    padding-block-start:var(
      --sic-accordion-block--accordion-spacing-above,
      var(--sic-accordion-block--default--accordion-spacing-above)
    );
  }

.image picture{
    display:grid;
  }

.image img{
    width:100%;
  }

.body{
  padding-block-start:var(--sic-accordion-block--default--content-spacing);
  padding-block-start:var(
    --sic-accordion-block--content-spacing,
    var(--sic-accordion-block--default--content-spacing)
  );
}

.body p{
    margin-top:0;
    font-size:var(--sic-accordion-block--default--content-font-size);
    font-size:var(
      --sic-accordion-block--content-font-size,
      var(--sic-accordion-block--default--content-font-size)
    );
  }

.body p:last-child{
      margin-bottom:0;
    }

.cta{
  padding-block-start:calc(
    var(--sic-accordion-block--default--content-spacing)
       * 2
  );
  padding-block-start:calc(
    var(
        --sic-accordion-block--content-spacing,
        var(--sic-accordion-block--default--content-spacing)
      ) * 2
  );
}
`;